// extracted by mini-css-extract-plugin
export default {"cursor":"StreamingText_cursor__GK1BE","blink":"StreamingText_blink__Q0emI"};